const search = {
  title: '查询到与 “$keyword” 相关的 $count 条结果',
  breadcrumbTitle: '搜索列表',
  searchLoadingText: '查询中，请稍候...',
  searchResultNone: '很抱歉，当前暂无匹配结果(づ◡﹏◡)づ',
  tabNav: [
    { label: '文章', value: '1', path: '/search/article' },
    { label: '产品', value: '2', path: '/search/product' },
  ]
}


export default search


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/search.js